import * as React from 'react';
export const DialogDragContext = React.createContext(void 0);
export const useDialogDragContext = () => {
  let context = React.useContext(DialogDragContext);
  return {
    ...context,
  };
};
